import { useThresholds } from '@util/customhooks/useThresholds';
import { NavLinkData } from '@util/navLinkData';
import React from 'react';
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';

export interface NavbarProps {
  links: NavLinkData[];
}

const Navbar = (props: NavbarProps) => {
  const { isAtLeastXL } = useThresholds();
  if (isAtLeastXL) {
    return <DesktopNavbar {...props}></DesktopNavbar>;
  } else {
    return <MobileNavbar {...props}></MobileNavbar>;
  }
};

export default Navbar;
